export class RelatedUserApp {
    constructor(item: any) {
        this.userApp_Id = item.app_id;
        this.name = item.label;
    }

    public userApp_Id: string = null;
    public name: string = null;
    public displayIndex: number;
}